import { AutomationRulesContainer } from 'modules/settings/pods/settings-automation-rules/automation-rules/automation-rules.container';

export const SettingsAutomationRulesScene = () => <AutomationRulesContainer />;

export default SettingsAutomationRulesScene;
